import { render, staticRenderFns } from "./HyphenArithmetic.vue?vue&type=template&id=4be4827b&scoped=true"
import script from "./HyphenArithmetic.vue?vue&type=script&setup=true&lang=js"
export * from "./HyphenArithmetic.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HyphenArithmetic.vue?vue&type=style&index=0&id=4be4827b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be4827b",
  null
  
)

export default component.exports